import { createApp } from 'vue'
import {i18nVue} from 'laravel-vue-i18n'
import register from './register.vue'

createApp({
	components: {
		register
	}
}).use(i18nVue, {
	resolve: async lang => {
		const langs = import.meta.glob('/resources/lang/*.json');
		return await langs[`/resources/lang/${lang}.json`]();
	}
}).mount('#register')
